import dynamic from 'next/dynamic';

const ArnmRepairsGrid = dynamic(() =>
  import('./ArnmRepairsGrid/ArnmRepairsGrid')
);
const AddArnmRepairsModal = dynamic(() =>
  import('./AddArnmRepairsModal/AddArnmRepairsModal')
);

const ArnmRepairsVehicleHeader = dynamic(() =>
  import('./ArnmRepairsVehicleHeader/ArnmRepairsVehicleHeader')
);
const ChangeArnmRepairsStage = dynamic(() =>
  import('./ChangeArnmRepairsStage/ChangeArnmRepairsStage')
);
const ArnmRepairsFilter = dynamic(() =>
  import('./ArnmRepairsFilter/ArnmRepairsFilter')
);
const RepairsForm = dynamic(() => import('./RepairsForm/RepairsForm'));
const ArnmRepaisContent = dynamic(() =>
  import('./ArnmRepaisContent/ArnmRepaisContent')
);

export {
  ArnmRepairsGrid,
  AddArnmRepairsModal,
  ArnmRepairsVehicleHeader,
  ChangeArnmRepairsStage,
  ArnmRepairsFilter,
  RepairsForm,
  ArnmRepaisContent,
};
